// src/store/index.js
import { createStore } from 'vuex';
import auth from './modules/auth';
import admin from './modules/admin';
import client from './modules/client';
import device from './modules/device';

export default createStore({
  modules: {
    auth,
    admin,
    client,
    device
  }
});
